import { render, staticRenderFns } from "./SideSubMenu.vue?vue&type=template&id=45e0d33c&scoped=true&"
import script from "./SideSubMenu.vue?vue&type=script&lang=js&"
export * from "./SideSubMenu.vue?vue&type=script&lang=js&"
import style0 from "./SideSubMenu.vue?vue&type=style&index=0&id=45e0d33c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e0d33c",
  null
  
)

export default component.exports